export default __webpack_public_path__ + "static/media/10.de202ae3.PNG";